.breadcrumbs {
    display: flex;
    flex-direction: row;
    width: 100%;
    list-style: none;
    align-items: center;
    gap: 1rem;
    background-color: #ffffff;
    filter: drop-shadow(2px 3px 3px #55555599);
    margin-top: 0;
    padding: 0.35rem 2rem;
    margin-bottom: 0rem;
    min-height: 3rem;
    z-index: 100;
  }
.breadcrumbs li:last-child a {
	font-weight:900;
}
  
  .breadcrumbs li {
    font-size: 1rem;
    display: flex;
    gap: 0.6rem;
    margin: 0;
  }
  
  .breadcrumbs a {
    line-height: 2rem;
    padding: 0;
    margin: 0;
    color: #505050;
  }
  
  .breadcrumbChevron {
    fill: #505050;
  }
  
  .breadcrumbs .active {
    color: #4a148c;
  }
  
  .breadcrumbs .linked:hover {
    text-decoration: underline;
    color: #4a148c;
  }
  
  .breadcrumbs li:first-child svg {
    display: block;
  }
  .step {
    display: none !important;
  }
  
  .previousStep .breadcrumb-chevron {
    transform: rotate(180deg);
  }
  
  .currentStep {
    display: none !important;
  }

  .breadcrumbsActions {
    margin-left: 0;
    margin-right: 0;
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: right;
    gap: 0.75rem;
    position: relative;
  }

  .breadcrumbSpacer {
    flex: 1 1 auto;
    margin: 0;
    padding: 0;
  }
